import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user'
Vue.use(Vuex);

// const state = {
//   screen: false,
//   sliderLength:0,
// }

// const actions = {

// }


// 更新状态
// const mutations = {

// 	screenSet(state,n){
// 		state.screen=n;
// 	},
// 	setSliderLength(state,n){
// 		state.sliderLength=n;
// 	}
// }


// 获取状态信息
// const getters = {
//   sliderLength: function(state) {
//     return state.sliderLength;
//   },
//   sliderScreen: function(state) {
//     return state.screen;
//   }
// }

// 下面这个相当关键了，所有模块，记住是所有，注册才能使用
const store = new Vuex.Store({
  // state,
  // mutations,
  // actions,
  // getters,
  modules: {
    user
  },
})
export default store
